import React from 'react'

import moment from 'moment'

import Modal from 'antd-v3/es/modal'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setCaregiverList } from 'src/store/modules/admin'
import { setCaregiverProfile } from 'src/store/modules/caregiver/profile'

import {
  CAREGIVER_MANAGEMENT_SAVE_MESSAGE,
  CAREGIVER_MANAGEMENT_SMS_MESSAGE,
  CAREGIVER_MANAGEMENT_UPDATE_MESSAGE,
  CAREGIVER_POST_SEND_SMS,
  CAREGIVER_POST_SET_PIN,
  DATE_TIME_FORMAT_FOR_SERVER,
  GET_CAREGIVER_LIST,
  GET_PATCH_DELETE_CAREGIVER,
  POST_CAREGIVER,
  READING_ANSWER_REPORTED_BY,
  REMOVE_DEVICE_ID
} from 'src/constants'
import { showSuccessModal, showWarningModal } from 'src/services/dialogs'
import { exportReport } from 'src/utils/Functions'

const getPatientLink = ({ uuid = null, fullName = '' }, history) => (
  <a
    href={`/patients/${uuid}/demographics`}
    onClick={(e) => {
      e.preventDefault()

      Modal.destroyAll()

      history.push(`/patients/${uuid}/demographics`)
    }}>
    {fullName}
  </a>
)

export const removeDeviceId =
  (config = {}) =>
  async () => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: REMOVE_DEVICE_ID
        },
        payload
      })
    } catch (err) {
      catchError(err)
    }
  }

export const fetchCaregiverList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_CAREGIVER_LIST,
          ...config
        }
      })

      dispatch(setCaregiverList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const saveCaregiver =
  (config = {}, history) =>
  async () => {
    try {
      const { connectedPatientByPhone } = await httpClient.request({
        method: 'post',
        url: { pathname: POST_CAREGIVER },
        ...config
      })

      if (!connectedPatientByPhone) {
        showSuccessModal({
          content: CAREGIVER_MANAGEMENT_SAVE_MESSAGE,
          centered: true,
          keyboard: false
        })
      } else {
        showWarningModal({
          content: (
            <span>
              Please remove the device ID from patient{' '}
              {getPatientLink(connectedPatientByPhone, history)}.
            </span>
          ),
          centered: true
        })
      }

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateCaregiver =
  (config = {}, showModal = true, history) =>
  async (dispatch) => {
    try {
      const { payload = {}, params = {} } = config

      const caregiver = await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_PATCH_DELETE_CAREGIVER,
          params
        },
        payload
      })
      const { connectedPatientByPhone } = caregiver

      dispatch(setCaregiverProfile(caregiver))

      if (showModal) {
        if (!connectedPatientByPhone) {
          showSuccessModal({
            content: CAREGIVER_MANAGEMENT_UPDATE_MESSAGE,
            centered: true,
            keyboard: false
          })
        } else {
          showWarningModal({
            content: (
              <span>
                Please remove the device ID from patient{' '}
                {getPatientLink(connectedPatientByPhone, history)}.
              </span>
            ),
            centered: true
          })
        }
      }

      dispatch(setCaregiverProfile(caregiver))

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportCaregivers =
  (config = {}) =>
  async () => {
    await exportReport(
      config,
      `caregivers_${moment().format(DATE_TIME_FORMAT_FOR_SERVER)}.xls`
    )
  }

export const setCaregiverPincode =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: CAREGIVER_POST_SET_PIN,
          params
        },
        payload
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const sendCaregiverSms =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: CAREGIVER_POST_SEND_SMS,
          params
        },
        payload
      })

      showSuccessModal({
        content: CAREGIVER_MANAGEMENT_SMS_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchReadingAnswerReportedBy = async (params, query) => {
  try {
    const r = await httpClient.request({
      method: 'get',
      url: {
        pathname: READING_ANSWER_REPORTED_BY,
        query,
        params
      }
    })

    return r
  } catch (err) {
    catchError(err)
  }
}
